<template>
  <!-- 侧边栏导航 -->
  <div class="asideposi" :height="height+'px !important'" style="overflow-y: auto;
    overflow-x: hidden;background-color:#F9F9F9">
    <!-- :default-active="openindex[0]" -->
    <el-menu
        :default-active="$route.path"
        :default-openeds="openindex"
        :unique-opened="true"
        collapse-transition
        :router="true"
        @select="menuSelected"
        class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      background-color="#F9F9F9"
      text-color="#333"
      active-text-color="#56B8AA">
        <nav-menu :navMenus="routers"></nav-menu>
      </el-menu> 
 <!--    <div class="asideposi" :height="height+'px !important'" style="overflow-y: auto;
    overflow-x: hidden;background-color: #F9F9F9">
      <div v-for="(item,num) in routers" class="aaa">
        <div style="width: 200px; background-color: rgb(249, 249, 249);"> 
          <ul v-if="item.grade == '1'" @click="clickNav(num)">
            <router-link :to="{path:item.path}" class="nav-zi">
              <li>
                <div class="single" :class="{ isActive : item.active=='Y' }" style="padding-left: 20px;">
                  <i :class="item.icon"></i> {{item.name}}
                  <i class=" el-icon-d-arrow-right jian"></i>
                </div>
              </li>
            </router-link>
          </ul> 
          <ul v-if="item.grade == '2'" style="cursor:pointer;" @click="opened(num,item.path)">
            <li>
              <div :class="{jianfangxiang : item.close}" style="padding-left: 20px;height:57px;line-height: 57px;position: relative;border-bottom: 1px solid #F2F2F2">
                <i :class="item.icon"></i> {{item.name}}<i class="el-submenu__icon-arrow el-icon-arrow-down"></i>
              </div>  
              <ul class="close trancss" :class="{isClose : item.close}" @click="opened(num,item.path)">
                <div v-for="(data,index2) in item.children">
                  <router-link :to="{path:data.path}" class="nav-zi">
                    <li tabindex="-1" class="single" :class="{isActive : data.path.substring(0, 15) == $route.path.substring(0, 15)}" style="padding-left: 40px;height: 50px;line-height: 50px;outline:none;border-bottom: 1px solid #F2F2F2;list-style: none;"> {{data.name}}
                    </li>
                  </router-link>
                </div>
              </ul>  
            </li>
          </ul>
        </div>
      </div>
    </div> -->
  </div>
</template>
<script>
//import axios from 'axios'
import NavMenu from './NavMenu.vue'
export default {
  // name: 'NavMenu',
  data() {
    return { 
      InterfacePath: '',
      utilpath: '',
      routerid: '',
      flag: false, //隐藏开关
      navbg1: true, //选中状态开关
      navbg2: false, //选中状态开关
      navbg3: false, //选中状态开关
      height: 0, //动态导航宽度
      openindex: [], //打开的导航下标
      row: "2",
      routepath: '', //下拉列表的选中下标
      routers: {}
    };
  },
  components:{
      NavMenu
  },
  mounted() {
    // 获取接口名
    this.InterfacePath = window.localStorage.getItem("InterfacePath");
    this.userInfo = JSON.parse(window.localStorage.getItem("userInfo")); 
    this.utilpath = this.axios.defaults.baseURL;
    this.init();
  },
  watch: { //监听路由变化
    
  },
  methods: {
    handleOpen(key, keyPath) {
        // console.log(key, keyPath);
        this.openindex=[];
        this.openindex[0]=key;
      },
      handleClose(key, keyPath) {
        // console.log(key, keyPath);
      },
    menuSelected(index,indexPath){
        // console.log('当前绑定的index值',index);
        // console.log('当前绑定的index与path值',indexPath);
    },
    clickNav(index) {
      this.routers[index].active = 'Y';
      window.localStorage.setItem("routers", JSON.stringify(this.routers));
      // console.log("点击状态：" + this.routers[index].active);
    }, 
    opened(num,id) {
      this.liheight = (this.routers[num].children.length) * 51;
      // console.log("li高度：" + this.liheight); 
      // console.log("11111111111单击this.routers[0].close"+this.routers[0].close);
      for (var i = 0; i < this.routers.length; i++) {
        if (i == num) {
          this.routers[i].close = !this.routers[i].close;
          // console.log("单击(i == num)循环内打印this.routers[i].close" + this.routers[i].close)
        } else {
          this.routers[i].close = true;
          // console.log("单击(i != num)循环内打印this.routers[i].close" + this.routers[i].close)
        }
      }
      sessionStorage.setItem("num", num);
      var num = sessionStorage.getItem("num");
      // console.log("打印num" + num); 
      this.routerid =id;
    }, 
    init() { 
      var route = JSON.parse(window.localStorage.getItem("routers")); 
     // // console.log("user" + JSON.stringify(JSON.parse(window.localStorage.getItem("userInfo"))));
      if (route != null) {
        this.routers = route;
        this.openindex.push(this.routers[0].pk_menu);
        // this.routers.forEach((item)=>{
        //     console.log("初始化菜单打印item："+JSON.stringify(item));
        //     if(item.close){
        //         this.openindex=[];
        //         this.openindex.push(item.pk_menu)
        //     }
        // });
        // console.log("silderinit打印routers" + JSON.stringify(route));
        // console.log("111111111111111111111111打印this.routers[0].close状态："+this.routers[0].close);
      } else {
         this.$http.post(this.utilpath + '/selectMenu', { emulateJSON: true,_timeout:600 }).then((res) => {
              // console.log("打印返回值res.data" + JSON.stringify(res.data));
              // this.$http.post('ktnapi/selectStore',reqparam,{emulateJSON:true}).then((res)=>{
              if (res.data.status == '0') {
                 this.fullscreenLoading = false;
                 if(this.userInfo.role_name=='门店管理员'){ 
                     this.routers = res.data.resultList[0].children; 
                     this.openindex.push(this.routers[0].pk_menu);
                 }else{
                  this.routers = res.data.resultList[1].children; 
                     this.openindex.push(this.routers[0].pk_menu); 
                 }
                 // console.log("打印菜单列表this.routers" + JSON.stringify(this.routers)); 
                 // console.log("打印菜单列表this.openindex" + JSON.stringify(this.openindex)); 
              } else if (res.data.status == '-1') {
                this.routers =[];
                this.fullscreenLoading = false;
                this.$message({
                  showClose:true,
                  message:'暂无菜单数据',
                  type:'info'
                })
                this.count = res.data.countNum;
                // console.log("-----暂无数据！！！");
              } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
            } else {
                    this.fullscreenLoading = false;
                    this.modelFlag = true;
                    this.msgShow = true;
                    this.methodName = 'message';
                    this.msg = res.data.message;
                    this.butflag =false;
                    this.butmsg='知道了'; 
            } 
            }, (err) => {
              this.fullscreenLoading = false;
              this.msgShow =false;
              this.modelFlag = true;
              this.methodName = 'message';
              this.msg = '连接获取所以菜单信息接口失败';
              this.butflag =false;
              this.butmsg='知道了'; 
              // console.log(err);
          });
         }
        
      var num = sessionStorage.getItem("num");

      // if (num != null) {
      //   this.routers[num].close = false;
      // }
      //动态获取导航高度
      this.height = document.documentElement.clientHeight - 60;
    }, 
  }
}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/silder3.vue